import type { EconomyTemplateDetail } from '@/types/economyTemplate';
import { convertOilUnitPrice } from '@/utils/scenarioUnits';

const PER_OIL_UNIT_ATTRS = new Set([
  'transport_per_unit',
  'oil_price',
  'additional_cost_per_oil_unit',
]);

export function normalizeCurrency(code: string): string {
  return code.trim().toUpperCase();
}

export function currenciesDiffer(a: string, b: string): boolean {
  return normalizeCurrency(a) !== normalizeCurrency(b);
}

export function attributesByName(template: EconomyTemplateDetail): Record<string, string> {
  const map: Record<string, string> = {};
  for (const attr of template.attributes) {
    if (attr.value != null && attr.value !== '') {
      map[attr.name] = attr.value;
    }
  }
  return map;
}

export function convertTemplateNumericValue(
  attrName: string,
  rawValue: string,
  templateUnitId: number,
  scenarioUnitId: number,
): string {
  if (!PER_OIL_UNIT_ATTRS.has(attrName)) {
    return rawValue;
  }
  const num = Number(rawValue);
  if (!Number.isFinite(num)) {
    return rawValue;
  }
  return String(convertOilUnitPrice(num, templateUnitId, scenarioUnitId));
}

export function templateUnitConversionNeeded(
  templateUnitId: number,
  scenarioUnitId: number,
): boolean {
  return templateUnitId !== scenarioUnitId;
}

/** Template currencies that differ from the scenario currency (when templates are applied). */
export function getMismatchedTemplateCurrencies(
  scenarioCurrency: string,
  fieldTemplate: EconomyTemplateDetail | null,
  layerTemplate: EconomyTemplateDetail | null,
): string[] {
  const scenario = normalizeCurrency(scenarioCurrency);
  const mismatched = new Set<string>();

  for (const template of [fieldTemplate, layerTemplate]) {
    if (!template) continue;
    const templateCurrency = normalizeCurrency(template.currency);
    if (templateCurrency !== scenario) {
      mismatched.add(templateCurrency);
    }
  }

  return [...mismatched].sort();
}
